module.exports = __webpack_public_path__ + "media/images/webpay-dc7949f6.jpg";